module.exports = __webpack_public_path__ + "static/2-2a42caea74af78200c79d1914a0fba21.png";